export default "__VITE_ASSET__By8P8R1s__"